import {
    makeStyles,
    createStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';

const styles = (theme: Theme) =>
    createStyles({
        developerPageContainer: {
            paddingTop: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                paddingTop: theme.spacing(3),
            },
        },
        gridContainer: {
            display: 'grid',
            gridTemplateColumns: '1fr',
            gap: `${theme.spacing(2)}px`,
            [theme.breakpoints.up('md')]: {
                gap: `${theme.spacing(4)}px`,
            },
        },
        twoCards: {
            display: 'grid',
            gap: `${theme.spacing(2)}px`,
            [theme.breakpoints.up('sm')]: {
                gridTemplateColumns: '1fr 1fr',
            },
            [theme.breakpoints.up('md')]: {
                gap: `${theme.spacing(4)}px`,
            },
        },
        threeCards: {
            display: 'grid',
            gap: `${theme.spacing(2)}px`,
            [theme.breakpoints.only('sm')]: {
                gridTemplateColumns: '1fr 1fr',
                gridTemplateRows: 'auto auto',
                '& > div:first-child': {
                    gridColumn: '1 / -1',
                },
            },
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: '1fr 1fr 1fr',
                gap: `${theme.spacing(4)}px`,
            },
        },
        stack: {
            display: 'grid',
            padding: '16px',
            gridGap: '16px',
        },
        unorderedList: {
            margin: 0,
            paddingLeft: theme.spacing(4),
        },
        orderedList: {
            margin: 0,
            paddingLeft: theme.spacing(2),
            display: 'grid',
            gridGap: theme.spacing(2),
        },
        // Looks like a link but is really a button
        linkButton: {
            justifyContent: 'flex-start',
        },
        linkButtonText: {
            marginRight: theme.spacing(0.5),
        },
        howToConnectLink: {
            display: 'inline-flex',
        },
        explorersName: {
            // Typescript complains when I use `theme.typography.fontWeightBold`
            fontWeight: 700,
        },
        fullWidthCard: {
            width: '100%',
        },
        connectionMethodsRow: {
            marginTop: theme.spacing(1),
            display: 'grid',
            rowGap: '2rem',
            columnGap: '5rem',
            gridTemplateColumns: '1fr',
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: '1fr 1fr',
                rowGap: '2rem',
                columnGap: '5rem',
            },
        },
        connectionMethodCard: {
            display: 'grid',
            gap: theme.spacing(0.5),
            padding: 0,
        },
        connectionMethodHeading: {
            margin: 0,
        },
        connectionMethodDescription: {
            margin: 0,
            marginBottom: theme.spacing(1.25),
        },
        connectionDetailsScrollBox: {
            width: '100%',
            overflowX: 'auto',
            overflowY: 'hidden',
            WebkitOverflowScrolling: 'touch',
        },
        connectionDetailsLoading: {
            minHeight: theme.spacing(18),
        },
        additionalResourcesSection: {
            marginTop: theme.spacing(2),
            display: 'grid',
            gap: theme.spacing(0.5),
        },
        connectionDetailsGrid: {
            display: 'grid',
            gridTemplateColumns: 'minmax(140px, 220px) auto auto',
            width: 'max-content',
            minWidth: 350,
            maxWidth: '100%',
            justifyContent: 'start',
            columnGap: theme.spacing(1.5),
            rowGap: theme.spacing(0.75),
            '@media (max-width:425px)': {
                gridTemplateColumns: 'minmax(96px, 114px) auto auto',
                columnGap: theme.spacing(1),
            },
            [theme.breakpoints.up('md')]: {
                gridTemplateColumns: 'minmax(170px, 240px) auto auto',
                columnGap: theme.spacing(2),
            },
        },
        connectionRowDivider: {
            gridColumn: '1 / -1',
            borderBottom: `1px solid ${theme.palette.divider}`,
            opacity: 0.45,
            marginTop: -theme.spacing(0.25),
        },
        connectionLabel: {
            fontWeight: theme.typography.fontWeightSemiBold,
            margin: 0,
            lineHeight: 1.3,
        },
        connectionValue: {
            margin: 0,
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            minWidth: 0,
            maxWidth: 'min(520px, 100%)',
            lineHeight: 1.3,
        },
        // Lets the copy button and its status line sit in the grid directly.
        copyCell: {
            display: 'contents',
            '& > button': {
                flexShrink: 0,
                marginLeft: '30px',
                marginTop: -2,
            },
        },
        // Spans the row under the copy button and draws the row divider.
        copyStatusRow: {
            gridColumn: '1 / -1',
            marginTop: -theme.spacing(0.25),
            '&::after': {
                content: '""',
                display: 'block',
                borderBottom: `1px solid ${theme.palette.divider}`,
                opacity: 0.45,
            },
        },
        copyColumnPlaceholder: {
            width: 24,
            height: 24,
            marginLeft: '30px',
        },
        snowflakeButton: {
            fontWeight: theme.typography.fontWeightSemiBold,
            display: 'inline-block',
            width: '250px',
            height: '45px',
            [theme.breakpoints.up('md')]: {
                width: '100%',
            },
        },
        errorText: {
            color: theme.palette.error.main,
        },
    });

const options = {
    name: 'DeveloperPage-',
};

export const useStyles = makeStyles(styles, options);
